export const BROKEN_SUBSCRIPTION_EDIT_DENIED_QUERY = 'edit-denied';
